import { CompanySpecificQuery } from "@enos-monorepo/lib/gql/graphql";
import { useTranslation } from "react-i18next";

import { ProseHtml } from "./components/ProseHtml";

interface CompanySpecificProps {
  companySpecificData?: CompanySpecificQuery;
}

export function CompanySpecific({ companySpecificData }: CompanySpecificProps) {
  const { t } = useTranslation();

  return (
    <div className="card">
      <div className="card-header flex flex-row justify-between py-[21px]">
        <h2 className="font-semibold text-2xl text-gray-900">
          {t("riskAnalyses.Company Specific")}
        </h2>
      </div>
      <div className="card-body">
        <ProseHtml html={companySpecificData?.companySpecific?.content?.html} />
      </div>
    </div>
  );
}
